// selectors
import { getPageName } from "../selectors/navigation";

const baseAction = "PAGEUPDATE";

export function StateChange(page, keyPath, value, info = "") {
	return (dispatch, getState) => {
		let pageName = page;

		if (pageName === null) {
			pageName = getState().router.location.pathname;
		}

		dispatch({
			type: `${baseAction}:CHANGE_STATE`,
			info,
			keyPath: [pageName].concat(keyPath),
			value,
		});
	};
}

export function MergeStateChange(page, keyPath, value) {
	return (dispatch, getState) => {
		let pageName = page;

		if (pageName === null) {
			pageName = getState().router.location.pathname;
		}

		dispatch({
			type: `${baseAction}:MERGE_CHANGE_STATE`,
			keyPath: [pageName].concat(keyPath),
			value,
		});
	};
}

/**
 * Will update the page state.
 *
 * @param {Array} keyPath - key path of the ui value
 * @param {any} value - next value of the given key path
 */
export const updateUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);

	dispatch(StateChange(pageName, keyPath, value));
};
